import { SxProps } from '@mui/material';
import { SnackbarTypes } from './types';

function showSnackbar(type: SnackbarTypes, message?: string, customSx?: SxProps) {
  dispatchEvent(
    new CustomEvent('show-snackbar', {
      detail: {
        type: type,
        message: message,
        open: true,
        customSx,
      },
    })
  );
}

export { showSnackbar };
